import React from 'react';
import { Trans } from 'react-i18next';
import toast, { Toaster, ToastBar } from 'react-hot-toast';

import { IconRcErrorToast } from '@/assets/components/systemToast';

import styles from './index.module.scss';
import { Link } from 'react-router-dom';

export const CenterToast = () => {
  return (
    <Toaster
      containerStyle={{ top: '68px' }}
      toastOptions={{
        className: styles.container,
      }}>
      {t => (
        <ToastBar
          toast={t}
          style={{
            ...t.style,
            animation: '',
          }}
        />
      )}
    </Toaster>
  );
};

export const suicideToast = () => {
  return toast(
    <div className={styles.toast}>
      <IconRcErrorToast className={styles.icon} />
      <Trans i18nKey="SystemErrorToast.suicide"></Trans>
    </div>,
    {
      duration: 3000,
    },
  );
};

export const streamActionToast = (context: 'trust' | 'distrust' | 'repost' | 'luckDraw') => {
  return toast(
    <div className={styles.streamActionToast}>
      <Trans i18nKey="SystemErrorToast.streamActionTrial" context={context}>
        Trial limit reached. Get permanent unlimited access to {context} by minting your
        <Link className={styles.link} to="/settings" onClick={() => toast.remove()}>
          Web3 ID.
        </Link>
      </Trans>
    </div>,
    {
      duration: 3000,
      style: { position: 'relative', top: '-54px' },
    },
  );
};
